// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tlt[data-v-036ca6fd] {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px dashed #80808052;\n  margin-bottom: 5px;\n}\n.tlt .el-button[data-v-036ca6fd] {\n  border: 0;\n}\n.plus[data-v-036ca6fd] {\n  margin-top: 5px;\n  width: 100%;\n}\n.flex[data-v-036ca6fd] {\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
